import { useSyncExternalStore } from 'react';
import { adminModalStore } from 'store/adminModalStore';

const useIsAdminModalOpen = () => useSyncExternalStore(
  adminModalStore.subscribe,
  adminModalStore.getSnapshot,
);
export default useIsAdminModalOpen;
